import type React from 'react';
import { Camera } from '@shared/assets';
import { AddressIcon } from '@shared/ui/smart-icons';
import { useAvailablePeriod } from '../../model';
import * as st from './styles.module.scss';

type Props = {
  id: number;
};

export const AvailableIcon: React.FC<Props> = ({ id }) => {
  const { availablePeriod } = useAvailablePeriod(id);

  // const addressId =
  // 	availablePeriod?.term.address && availablePeriod.address.length > 0
  // 		? availablePeriod.address[0].id
  // 		: undefined;
  const addressId = availablePeriod?.terms[0]?.address?.index || -1;

  const icons: { [x: string]: JSX.Element } = {
    ON: <Camera />,
    OF: <AddressIcon id={addressId} />,
  };

  // return availablePeriod && availablePeriod.status.length > 0 ? (
  //   <div className={st.icon} onMouseOver={(e) => e.stopPropagation()}>
  //     {availablePeriod?.status.map((stat) => (
  //       <React.Fragment key={stat}>{icons[stat]}</React.Fragment>
  //     ))}
  //   </div>
  // ) : (
  //   <></>
  // );
  const periodStatusOnOF = availablePeriod?.terms[0].status;
  return (
    periodStatusOnOF && (
      <div className={st.icon} onMouseOver={(e) => e.stopPropagation()}>
        {icons[periodStatusOnOF]}
      </div>
    )
  );
};
